<!--
 * @Description: 访客计划 -- 查看页面
 * @Author: mdb
 * @Date: 2022-07-19 11:12:06
 * @LastEditTime: 2022-11-07 16:33:58
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" tab="计划详情">
            <VisitorProgramForm
              ref="visitorProgramFormRef"
              title="访客计划详情"
              v-model:value="dataForm"
              type="view"
              :isEdit="false"
            />
          </a-tab-pane>
          <a-tab-pane key="logs" tab="操作日志">
            <TabsOperationLog appId="cos_lbu" tableId="LbuVisitorOperationLog" :resourceId="route.query.id as string" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <!-- <SellerButton :workCode="dataForm.createBy" controlType="none" @click="handleEdit()">编辑</SellerButton> -->
      <SellerButton
        v-permission="'lbu_visitor_complete_btn'"
        :workCode="dataForm.createBy"
        controlType="none"
        type="primary"
        :disabled="[3, 4].includes(dataForm.status as number)"
        @click="handleVisitComplete()"
        >完成计划</SellerButton
      >
    </cos-footer-button>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramDetail } from '@/api/yuntuSales/followUpManage'
import type { LbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
const router = useRouter()
const route = useRoute()

const dataForm = reactive<LbuVisitorProgramEditParams>({})

onBeforeMount(() => {
  visitorProgramDetail(route.query.id as string).then((res) => {
    Object.assign(dataForm, res.data)
  })
})

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

const visitorProgramFormRef = ref()
const handleVisitComplete = (row = dataForm) => {
  router.push({ path: '/lbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
// const handleEdit = () => {
//   router.push({ path: '/lbu/visitorProgram/edit', query: { id: route.query.id as string } })
// }
</script>
<script lang="ts">
export default { name: 'DcCosLbuVisitorProgramView' }
</script>

<style scoped></style>
